<template>
  <div class="page-content">
    <page-template
      ref="plusTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <div class="statistics-box">
      <div class="statistics-item">
        <div class="txt">支付宝</div>
        <div class="txt num">元</div>
      </div>
      <div class="statistics-item">
        <div class="txt">微信</div>
        <div class="txt num">元</div>
      </div>
      <div class="statistics-item">
        <div class="txt">总交易净额</div>
        <div class="txt num">元</div>
      </div>

    </div>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    pageTemplate

  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
          labelWidth: '130px',
          simple: [
            {
              label: "门店名称", prop: "storeId", span: 12, type: "select", data: [],
              url: api.system.seStore
            }
          ],
          complex: [
            {label: "复购次数", prop: "purchaseCount", type: "input", span: 12, placeholder: "请输入复购次数"},
            {label: "会员名称", prop: "name", type: "input", span: 12, isFuzzy: true, placeholder: "请输入会员名称"},
            {label: "手机号", prop: "phone", type: "input", span: 12, isFuzzy: true, placeholder: "请输入手机号"},
            {label: "激活时间", prop: "startTime", type: "datetimeRange", dateType: "datetime", span: 12},
            {label: "生日时间", prop: "startTime", type: "datetimeRange", dateType: "datetime", span: 12},
            {label: "沉睡时间", prop: "startTime", type: "datetimeRange", dateType: "datetime", span: 12},
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '导出会员信息',
            code: 'memberExport',
            callback: this.goodsDetailExport
          },
          {
            label: '积分清零',
            code: 'integralReset',
            callback: this.integralReset
          },
          {
            label: '余额退款',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '冻结',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '挂失',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '编辑信息',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '密码',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '记录',
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          param: {openPlus: true},
          columns: [
            {label: '呢称/姓名', prop: 'name', width: '120', align: 'center'},
            {label: '手机号', prop: 'phone', width: '120', align: 'center'},
            {label: '积分', prop: 'usableIntegral', width: '120', align: 'center'},
            {label: '余额', prop: 'balance', width: '120', align: 'center'},
            {label: '复购次数', prop: 'purchaseCount', width: 120, align: 'center'},
            {label: '生日', prop: 'memberBirthday', width: '120', align: 'center'},
            {label: '注册时间', prop: 'createDttm', width: '180', align: 'center'},
            {label: '会员有效期', prop: 'memberTerm', width: '120', align: 'center'},
            {label: '门店名称', prop: 'storeName', width: '120', align: 'center'},
            {
              label: '状态',
              prop: 'status',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('mbMember.status')
            },
          ],
          url: api.member.archives
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.simple);
    },
    methods: {
      integralReset() {
        // 需要同步的数据
        console.log("222222")
        let tableRows = this.$refs.plusTemplate.getTableSelectRow();
        console.log(tableRows);
        if (tableRows.length === 0) {
          this.$message({message: '请勾选数据后进行积分清零', type: 'warning'});
          return;
        }
        this.$axios
          .fetchPost(api.member.archives + '/integral/reset', {mbMemberList: tableRows})
          .then(data => {
            if (data.code === 200 && data.data) {
              this.$notify({
                type: "success",
                title: '会员积分清零操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '会员积分清零成功', type: 'success'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
        });
      },
      goodsDetailExport() {
        this.$axios.fetchPost(api.member.archivesExport, {
          openPlus: true,
          exportCode: 'MbPlusMemberExport'
        }).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '导出异常', type: 'error'});
          }
        })
      }
    }
  };
</script>

<style scoped>
  @import "../../assets/style/plus.css";
</style>



// WEBPACK FOOTER //
// src/page/member/Plus.vue